function initFooterModal() {
    if (null === document.querySelector('.maier-footer *[data-modal="true"]')) {
        return;
    }

    let footerModal = new Modal({
        'id': 'maier-modal-footer',
        'create': true,
    });

    new AjaxLink({
        selector: '.maier-footer *[data-modal="true"]',
        targetElements: {
            '#maier-modal-footer > .modal-content .content' : 'main .content'
        },
        isTriggerReplace: false,
        callback: function() {
            footerModal.show();
        }
    });
}

function setupFooterModal() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initFooterModal();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFooterModal);
} else {
    setupFooterModal();
}